import React, { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';

const Navbar = () => {

    const [isSticky, setIsSticky] = useState(false);
    
    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 40) { // Adjust the scroll threshold as needed
                setIsSticky(true);
            } else {
                setIsSticky(false);
            }
        };

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    return (
        <>
            <nav className={`navbar navbar-expand-sm ${isSticky ? 'sticky-bg' : ''} bg-light custom-nav-bar navbar-light fixed-top`}>
                <div className="container">
                    <Link className="navbar-brand" to="/">
                        <img alt="krisantec logo" src={require('../assets/images/logo.png')} width="200" />
                    </Link>
                    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#collapsibleNavbar">
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    <div className="collapse navbar-collapse" id="collapsibleNavbar">
                    <ul className="navbar-nav m-auto">
                    <li className="nav-item">
                        <Link className="nav-link jumplink" to="/">Home</Link>
                    </li>
                    <li className="nav-item">
                        <Link className="nav-link jumplink" to="/about">About</Link>
                    </li>
                    <li class="nav-item dropdown">
                        <a class="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown">Services</a>
                        <ul class="dropdown-menu">
                            <li>
                                <Link className="dropdown-item" to="/services/it-development-consulting">IT Development & Consulting</Link>
                                <Link className="dropdown-item" to="/services/digital-marketing" >Digital Marketing</Link>
                                <Link className="dropdown-item" to="/services/business-domains" >Business Domains</Link>
                                <Link className="dropdown-item" to="/services/business-process" >Business Process</Link>
                            </li>
                        </ul>
                    </li>
                    
                    <li className="nav-item">
                        <Link className="nav-link jumplink" to="/contact-us">Contact</Link>
                    </li>    
                    </ul>
                </div>
                </div>
            </nav>
            <div className="whatsapp-contact" >
                    <a href="https://api.whatsapp.com/send?phone=918008449532&text=Hi+I+want+to+know+more+about+your+services" target='_blank'>
                        <img alt="krisantec img" src={require('../assets/images/whatsapp1.webp')} />
                    </a>
                </div>
        <div class="belownav"></div>
        </>
    );
};

export default Navbar;